define((require) => {
    "use strict";

    const Backbone   = require("backbone");
    const Breakpoint = require("shared/ui/breakpoint/Breakpoint");

    const SMALL  = "Small";
    const MEDIUM = "Medium";
    const LARGE  = "Large";

    /**
     * Collection of <tt>Breakpoint</tt>'s.
     *
     * @class BreakpointCollection
     */
    return Backbone.Collection.extend({

        model: Breakpoint,

        comparator(breakpoint) {
            return breakpoint.get("threshold");
        },

        /**
         * Whether the specified threshold matches any of the contained breakpoints.
         *
         * @param  {Number} threshold The threshold value.
         * @return {Boolean}          <tt>true</tt> if the specified threshold matches any of the contained breakpoints.
         */
        containsThreshold(threshold) {
            return !!this.findWhere({threshold});
        },

        getThresholds() {
            return this.map((breakpoint) => breakpoint.get("threshold"));
        },

        /**
         * Get all lower bounds of the configured breakpoints.
         * @returns {Breakpoint[]}  An array of breakpoints including the 0 threshold
         */
        getLowerBounds() {
            return [new Breakpoint({threshold: 0})].concat(this.models);
        },

        /**
         * Generate naming for breakpoint intervals. Support unlimited number of breakpoints.
         *
         * 1 breakpoint / 2 intervals: [Small, Large]
         * 2 breakpoints / 3 intervals: [Small, Medium, Large]          <-- Default
         * 3 breakpoints / 4 intervals: [XSmall, Small, Medium, Large]
         * 4 breakpoints / 5 intervals: [XSmall, Small, Medium, Large, XLarge]
         * 5 breakpoints / 6 intervals: [XXSmall, XSmall, Small, Medium, Large, XLarge]
         * etc.
         *
         * @param {Number} length The total number of breakpoints.
         * @returns {String[]} naming Array of denotations for each interval.
         */
        generateNaming(length) {
            const breakpointCount = length || this.length;
            let naming = [];

            switch (breakpointCount) {
                case 0: {
                    naming = [];
                    break;
                }

                case 1: {
                    naming = [SMALL, LARGE];
                    break;
                }

                default: {
                    naming = [SMALL, MEDIUM, LARGE];

                    let prefix = "X";
                    const remainCount = breakpointCount - 2;

                    for (let i = 0; i < remainCount; i += 2) {
                        naming.unshift(`${prefix}S`);

                        if (i + 1 < remainCount) {
                            naming.push(`${prefix}L`);
                        }

                        prefix = `X${prefix}`;
                    }

                    break;
                }
            }

            return naming;
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/breakpoint/BreakpointCollection.js